import React from 'react';

export const NoMatchPage = () => {
  return <h1>This page cannot be found</h1>;
};
